module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "delay"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('svg', {
    staticClass: "circular",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none",
      "stroke-width": "2",
      "stroke-miterlimit": "10"
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3157d9b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Loader.vue
// module id = 469
// module chunks = 225